<template>
  <a
    :href="to"
    class="uppercase font-light text-sm mx-4
    hover:border-secondary-0 hover:text-secondary-0 transition-colors duration-150
    lg:p-4 py-3 px-0 block border-b-2 border-transparent"
    @click="uncheck"
  >
    <slot />
  </a>
</template>
<script>
export default {
  name: 'navitem',
  props: ['to'],
  methods: {
    uncheck() {
      document.getElementById('menu-toggle').checked = false;
    },
  },
};
</script>
